import { POP_ALERT, DESTROY_ALERT } from './types';

const defaultTimeout = 5000; //5 seconds

export const popAlert = (className, timeout = defaultTimeout, children) => dispatch => {
    return dispatch({
        type: POP_ALERT,
        payload: { id:Math.random(), children, className, timeout }
    });
}
export const destroyAlert = (id) => dispatch => {
    return dispatch({
        type: DESTROY_ALERT, payload: id
    })
};

export const alertSuccess = (children, timeout = defaultTimeout) => popAlert("alert-success", timeout, children);

export const alertInfo = (children, timeout = defaultTimeout) => popAlert("alert-info", timeout, children);

export const alertWarning = (children, timeout = defaultTimeout) => popAlert("alert-warning", timeout, children);

export const alertDanger = (children, timeout = defaultTimeout) => popAlert("alert-danger", timeout, children);

export const noTimeOut = null;
